/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie = function (b, j, m) { if (typeof j != "undefined") { m = m || {}; if (j === null) { j = ""; m.expires = -1 } var e = ""; if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) { var f; if (typeof m.expires == "number") { f = new Date(); f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000)) } else { f = m.expires } e = "; expires=" + f.toUTCString() } var l = m.path ? "; path=" + (m.path) : ""; var g = m.domain ? "; domain=" + (m.domain) : ""; var a = m.secure ? "; secure" : ""; document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("") } else { var d = null; if (document.cookie && document.cookie != "") { var k = document.cookie.split(";"); for (var h = 0; h < k.length; h++) { var c = jQuery.trim(k[h]); if (c.substring(0, b.length + 1) == (b + "=")) { d = decodeURIComponent(c.substring(b.length + 1)); break } } } return d } };

/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 */
Shopify.Products = (function () {
  // Constants
  const COOKIE_NAME = 'shopify_recently_viewed';
  const POPUP_TEMPLATE = 'recently-viewed-product-popup';
  const DEFAULT_CONFIG = {
    howManyToShow: 8,
    howManyToStoreInMemory: 10,
    wrapperId: 'recently-viewed-products',
    templateId: 'recently-viewed-product-template',
    layout: 'slider',
    swipe: true,
    media: 'adapt',
    onComplete: null,
  };
  const COOKIE_CONFIG = {
    expires: 90,
    path: '/',
    domain: window.location.hostname,
  };

  // Cookie management
  const cookie = {
    name: COOKIE_NAME,
    configuration: COOKIE_CONFIG,
    write(recentlyViewed) {
      const value = Array.isArray(recentlyViewed) ? recentlyViewed.join(' ') : '';
      jQuery.cookie(this.name, value, this.configuration);
      localStorage.setItem(this.name, value);
    },
    read() {
      let cookieValue = jQuery.cookie(this.name);
      if (Shopify.designMode && !cookieValue) {
        cookieValue = localStorage.getItem(this.name);
      }
      return cookieValue ? cookieValue.split(' ').filter(Boolean) : [];
    },
    destroy() {
      jQuery.cookie(this.name, null, this.configuration);
      localStorage.removeItem(this.name);
    },
    remove(productHandle) {
      const recentlyViewed = this.read();
      const index = recentlyViewed.indexOf(productHandle);
      if (index !== -1) {
        recentlyViewed.splice(index, 1);
        this.write(recentlyViewed);
      }
    },
  };

  // Helper: Sanitize ID to prevent XSS
  const sanitizeId = (id) => String(id).replace(/[^a-zA-Z0-9-_]/g, '');

  // Helper: Fetch product via AJAX
  const fetchProduct = async (handle, view, sectionId = '') => {
    const url = `${window.routes?.root || ''}/products/${handle}?view=${view}`;
    try {
      const response = await jQuery.ajax({ type: 'GET', url, cache: false });
      return { success: true, data: response };
    } catch (error) {
      return { success: false, error };
    }
  };

  // Helper: Update form IDs for variants
  const updateFormIds = ($container, sectionId) => {
    $container.find('.card-product .variants-popup-content .selector-wrapper .swatch-element').each(function () {
      const $input = $(this).find('input');
      const $label = $(this).find('label');
      $input.attr({
        id: `${$input.attr('id') || ''}${sectionId}`,
        name: `${$input.attr('name') || ''}${sectionId}`,
      });
      $label.attr('for', `${$label.attr('for') || ''}${sectionId}`);
    });

    $container.find('.card-product').each(function () {
      const $qsForm = $(this).find('.variants-popup-content form');
      const $acForm = $(this).find('.card-action form');
      const $select = $(this).find('.variants-popup-content select');
      const $acButton = $(this).find('.card-action form button');
      const $qsButton = $(this).find('.variants-popup-content .product-card__button2 button');

      $qsForm.attr('id', `${$qsForm.attr('id') || ''}${sectionId}`);
      $acForm.attr('id', `${$acForm.attr('id') || ''}${sectionId}`);
      $select.attr('id', `${$select.attr('id') || ''}${sectionId}`);
      $acButton.attr('data-form-id', `${$acButton.attr('data-form-id') || ''}${sectionId}`);
      $qsButton.attr('data-form-id', `${$qsButton.attr('data-form-id') || ''}${sectionId}`);
    });
  };

  // Helper: Initialize Slick slider
  const initSlickSlider = ($grid, config) => {
    const {
      itemToShow = 4,
      itemDots = true,
      itemDotsMb = true,
      itemArrows = true,
      itemArrowsMb = true,
    } = $grid.data() || {};

    // Clean up existing Slick instance
    if ($grid.hasClass('slick-initialized')) {
      $grid.slick('unslick');
    }

    // Add counter and progress bar
    if (!$grid.parent().find('.slick-counter').length) {
      $grid.after('<div class="slick-counter" role="status" aria-live="polite"><span class="current-slide">1</span> / <span class="total-slides"></span></div>');
    }
    if (!$grid.parent().find('.progress_path').length) {
      $grid.after(`
        <div class="progress_path">
          <div class="progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
            <span class="slider__label sr-only">0% completed</span>
          </div>
        </div>
      `);
    }

    // Initialize Slick
    $grid.slick({
      vertical: false,
      infinite: false,
      slidesToShow: itemToShow,
      slidesToScroll: 1,
      arrows: itemArrowsMb,
      dots: itemDotsMb,
      nextArrow: window.arrows?.icon_next || '<button>Next</button>',
      prevArrow: window.arrows?.icon_prev || '<button>Prev</button>',
      rtl: window.rtl_slick || false,
      responsive: [
        {
          breakpoint: 1599,
          settings: { arrows: itemArrows, dots: itemDots, slidesToShow: itemToShow || 1, slidesToScroll: itemToShow || 1 },
        },
        {
          breakpoint: 1024,
          settings: { arrows: itemArrows, dots: itemDots, slidesToShow: itemToShow === 5 ? 4 : itemToShow || 1, slidesToScroll: itemToShow === 5 ? 4 : itemToShow || 1 },
        },
        { breakpoint: 991, settings: { arrows: itemArrowsMb, dots: itemDotsMb, slidesToShow: 4, slidesToScroll: 4 } },
        { breakpoint: 767, settings: { arrows: itemArrowsMb, dots: itemDotsMb, slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 600, settings: { arrows: itemArrowsMb, dots: itemDotsMb, slidesToShow: 1.3, slidesToScroll: 1 } },
      ],
    });

    // Update counter and progress bar
    const $counter = $grid.parent().find('.slick-counter');
    const $progressBar = $grid.parent().find('.progress_path .progress');
    const $progressBarLabel = $progressBar.find('.slider__label');
    const totalSlides = $grid.find('.slick-slide:not(.slick-cloned)').length;
    $counter.find('.total-slides').text(totalSlides);

    const updateProgressBar = (currentSlide) => {
      const calc = ((currentSlide + 1) / totalSlides) * 100;
      $progressBar
        .css('background-size', `${calc}% 100%`)
        .attr('aria-valuenow', calc);
      $progressBarLabel.text(`${Math.round(calc)}% completed`);
    };

    updateProgressBar(0);
    $grid.on('afterChange', (event, slick, currentSlide) => {
      $counter.find('.current-slide').text(currentSlide + 1);
      updateProgressBar(currentSlide);
    });
  };

  // Finalize rendering
  const finalize = ($wrapper, config) => {
    const $items = $wrapper.find('.item');
    if ($items.length <= 2) {
      $('#recently-viewed-products-list').addClass('center');
    }
    $('#recently-viewed-products-list-2').addClass('recently-viewed-loaded');
    $wrapper.show();
    if (typeof config.onComplete === 'function') {
      try {
        config.onComplete();
      } catch (error) {
        console.warn('Error in onComplete callback:', error);
      }
    }
  };

  // Render popup products
  const renderPopupProducts = async ($wrapper, handles, maxToShow) => {
    const wanted = handles.slice(0, maxToShow);

    /*
     * One request per card, all in flight at once. This used to await inside a while
     * loop, so eight cards meant eight serialised round trips - and the section view is
     * served no-cache, no-store, so every one of them is a full origin hit. Promise.all
     * preserves array order, so the cards still render newest-first no matter which
     * response lands first.
     */
    const results = await Promise.all(
      wanted.map((handle) => fetchProduct(handle, 'ajax_recently_viewed'))
    );

    results.forEach((result, index) => {
      if (result.success) {
        $wrapper.append(result.data);
      } else {
        cookie.remove(wanted[index]);
      }
    });

    finalize($wrapper, DEFAULT_CONFIG);
  };

  // Render section products
  const renderSectionProducts = async ($wrapper, handles, maxToShow, config) => {
    const $recentlyViewed = $wrapper.parents('.halo-recently-viewed-block');
    const sectionId = sanitizeId($recentlyViewed.attr('sectionid') || '');

    // Moved ahead of the fetches: with no handles there was never anything to request,
    // and it keeps Promise.all off an empty list.
    if (handles.length === 0) {
      $recentlyViewed.hide();
      return;
    }

    const wanted = handles.slice(0, maxToShow);

    // All cards requested together rather than one after another - see renderPopupProducts.
    const results = await Promise.all(
      wanted.map((handle) => fetchProduct(handle, 'ajax_section_recently_viewed', sectionId))
    );

    let appended = 0;
    results.forEach((result, index) => {
      if (!result.success) {
        console.warn(`Failed to load product: ${wanted[index]}`);
        return;
      }
      $wrapper.append(result.data);
      appended++;
    });

    if (appended > 0) {
      /*
       * Keyed on "at least one card arrived" instead of the old "the first handle
       * arrived": if that first request failed, the placeholder cards were left on
       * screen for good, underneath the products that did load.
       */
      $wrapper.find('.product-item--loadingNoInfo, .product-item--loadingNoInfo_').parents('.product').remove();

      /*
       * Called once, over the finished row. It appends sectionId to the ids it finds
       * across the whole block, so running it after every append gave the first card's
       * inputs the suffix repeated once per remaining product.
       */
      updateFormIds($recentlyViewed, sectionId);
    }

    if (config.layout === 'slider') {
      initSlickSlider($wrapper, config);
    }

    // Additional Shopify-specific handlers
    if ($('body').hasClass('cursor-fixed__show')) {
      window.sharedFunctionsAnimation?.onEnterButton?.();
      window.sharedFunctionsAnimation?.onLeaveButton?.();
    }
    if ($('body').hasClass('product-card-layout-08')) {
      window.sharedFunctions?.productCountdownCard?.();
    }
    window.sharedFunctions?.swapHoverVideoProductCard?.();

    finalize($wrapper, config);
  };

  return {
    resizeImage(src, size) {
      if (!size) return src;
      if (size === 'master') return src.replace(/http(s)?:/, '');
      const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
      if (match) {
        const [prefix, suffix] = src.split(match[0]);
        return `${prefix}_${size}${suffix}`.replace(/http(s)?:/, '');
      }
      return null;
    },

    showRecentlyViewed(params = {}) {
      const config = { ...DEFAULT_CONFIG, ...params };
      if (!config.wrapperId || !config.templateId) {
        console.warn('Missing wrapperId or templateId');
        return;
      }

      const recent = cookie.read();
      const defaultHandles = ["aaron-occasional-chair_354","addison-bench_1305","addison-dining-table_1304","adeline-candle-holder_1729","aden-stripe-throw_1060","afrique-leather-1-seater-chair_1176"] || [];
      if (!Array.isArray(defaultHandles)) {
        console.warn('Invalid defaultHandles');
        return;
      }

      const uniqueHandles = [...new Set([...recent, ...defaultHandles])];
      const productHandles = uniqueHandles.slice(0, config.howManyToShow);
      const $wrapper = jQuery(`#${sanitizeId(config.wrapperId)}`);
      if (!$wrapper.length) {
        console.warn(`Wrapper #${config.wrapperId} not found`);
        return;
      }

      const maxToShow = Math.min(productHandles.length, config.howManyToShow);
      if (maxToShow === 0) return;

      if (config.templateId === POPUP_TEMPLATE) {
        renderPopupProducts($wrapper, productHandles, maxToShow);
      } else {
        renderSectionProducts($wrapper, productHandles, maxToShow, config);
      }
    },

    getConfig() {
      return { ...DEFAULT_CONFIG };
    },

    clearList() {
      cookie.destroy();
    },

    recordRecentlyViewed(params = {}) {
      const config = { ...DEFAULT_CONFIG, ...params };
      const recentlyViewed = cookie.read();

      if (window.location.pathname.includes('/products/')) {
        const match = window.location.pathname.match(/\/products\/([a-z0-9-_]+)/);
        const productHandle = match ? match[1] : decodeURIComponent(window.location.pathname.split('/products/')[1]);
        
        const position = recentlyViewed.indexOf(productHandle);
        if (position === -1) {
          recentlyViewed.unshift(productHandle);
        } else {
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);
        }

        cookie.write(recentlyViewed.slice(0, config.howManyToStoreInMemory));
      }
    },
  };
})();